import { useRef, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
    width: ${({ inputWidth }) => inputWidth};
    /* filter: none !important; */
    /* background-color: ${({ theme }) => theme.mainBgColor}; */
    position: relative;
    border-radius: 10px;
    height: 100%;
    /* border: 1px solid ${({ theme }) => theme.mainBorderColor};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding-right: 10px; */
    textarea {
        width: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: none;
        color:  ${({ theme }) => theme.mainTextColor};

        background-color: ${({ theme }) => theme.mainBgColor};
        resize: none;
        min-height: 50px;
        max-height: 140px; /* 5 satıra kadar büyüme için max height */
        border-radius: 10px;
        line-height: 1.4;
        overflow-y: auto;
        &::-webkit-scrollbar {
            height: 8px;
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.secondaryTextColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    .send {
        cursor: pointer;
        border-radius: 50%;
        padding: 10px;
        background-color: var(--color-main);
        display: flex;
        align-items: center;
        justify-content: center;

        &:disabled{
            cursor: initial;
            background-color: ${({theme}) => theme.secondaryBgColor};
        }

        svg {
            width: 20px;
            height: 20px;
            color: #fff;
        }
    }

    textarea:focus ~ label {
        color: ${({ theme }) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label {
        position: absolute;
        transform: ${({ value }) => value && "translateY(-22px)"};
        top: 14px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition: all 0.3s ease;
        z-index: 5;
        color: ${({ theme, value }) => (value ? theme.mainTextColor : theme.secondaryTextColor)};
        background-color: ${({ theme }) => theme.mainBgColor};
    }
    .button-container{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }
`;

const MessageInputTextArea = ({ data, setData, name, inputWidth, labelText, disabled, onKeyDown, handleSubmit, placeholder }) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 140)}px`;
        }
    }, [data]);

    return (
        <Container inputWidth={inputWidth} value={data}>
            <textarea
                ref={textareaRef}
                onKeyDown={onKeyDown}
                id={"text"}
                onChange={setData}
                value={data}
                name={name}
                placeholder={placeholder}
            /> 
            <label htmlFor={"text"}>{labelText}</label>
            {/* <div className="button-container">
                <button className="send" disabled={disabled} onClick={handleSubmit}>
                    <BsFillSendFill />
                </button>
            </div> */}
            
        </Container>
    );
};

export default MessageInputTextArea;
